
export const formatValue = (value, format) => {
  if (value == null) return null;

  switch (format) {
    case 'currency':
      return `$${Number(value).toLocaleString()}`;
    case 'percent':
      return `${Number(value).toFixed(1)}%`;
    case 'number':
      return Number(value).toLocaleString();
    case 'date':
      return new Date(value).toLocaleDateString();
    case 'text':
    default:
      return String(value);
  }
};
